import { useState } from "react";
import { motion } from "framer-motion";

export const OurProducts = (props: any) => {
  const [selected, setSelected] = useState(0);

  return (
    <section className="relative py-28 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between gap-10 mb-20">
          
          {/* Left */}
          <div className="lg:w-1/2">
            <p className="text-red-600 font-semibold uppercase tracking-wider mb-2">
              {props.subTitle}
            </p>

            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight relative">
              {props.title}
              
              {/* Minimal Accent Underline */}
              <span className="absolute -bottom-2 left-0 w-24 h-1 bg-red-600 rounded-full"></span>
            </h2>
          </div>

          {/* Right */}
          <div className="lg:w-1/2 flex items-center">
            <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
              {props.description}
            </p>
          </div>
        </div>

        {/* Content Layout */}
        <div className="flex flex-col lg:flex-row gap-12">
          
          {/* Accordion */}
          <div className="lg:w-1/3 space-y-5">
            {props.productsList.map((product: any, idx: number) => {
              const isOpen = selected === idx;

              return (
                <div
                  key={idx}
                  className={`
                    rounded-xl border 
                    transition-all duration-300 cursor-pointer
                    ${isOpen 
                      ? "bg-white border-red-500 shadow-lg" 
                      : "bg-white border-gray-200 shadow-sm hover:shadow-md"
                    }
                  `}
                >
                  {/* Title bar */}
                  <div
                    onClick={() => setSelected(idx)}
                    className={`
                      flex justify-between items-center px-5 py-4
                      transition-colors duration-300 rounded-xl
                      ${isOpen 
                        ? "bg-red-600 text-white" 
                        : "bg-white text-gray-900"
                      }
                    `}
                  >
                    <h3 className="text-lg font-semibold">{product.title}</h3>

                    <motion.span
                      animate={{ rotate: isOpen ? 90 : 0 }}
                      transition={{ duration: 0.3 }}
                      className="text-2xl font-bold"
                    >
                      →
                    </motion.span>
                  </div>

                  {/* Description */}
                  <motion.div
                    initial={false}
                    animate={{
                      height: isOpen ? "auto" : 0,
                      opacity: isOpen ? 1 : 0,
                    }}
                    transition={{ duration: 0.4 }}
                    className="overflow-hidden"
                  >
                    <div className="px-5 py-4 text-gray-700 leading-relaxed">
                      {product.desc}
                    </div>
                  </motion.div>
                </div>
              );
            })}
          </div>

          {/* Image Section */}
          <div className="lg:w-2/3">
            <motion.img
              key={selected}
              src={props.productsList[selected].image}
              alt={props.productsList[selected].title}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="
                w-full h-[360px] sm:h-[420px] md:h-[520px]
                object-cover rounded-3xl shadow-xl
                hover:scale-[1.03] transition-transform duration-500
              "
            />
          </div>
        </div>
      </div>
    </section>
  );
};
